import axios from "axios";
import moment from "moment";

import { getAuthorizationHeader } from "./auth_service";
import { convertFilterQueryParams } from "./strapi_utils";

const qs = require("qs");

export const putOffer = async (id, body) => {
  let res = await axios.put(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers/${id}`,
    { data: body },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const createOffer = async (body) => {
  body.status = "Publicado";
  body.publication_date = moment().format("YYYY-MM-DD"); // STRAPI FORMAT.

  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers`,
    { data: body },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getOfferById = async (id) => {
  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers/${id}?populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};


export const getOfferByIds = async (idList) => {
  const query = qs.stringify(
    {
      filters: {
          id: {
            $in: idList,
          },
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers?populate=*&${query}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};


export const getOffers = async (accId) => {
  const role = localStorage.getItem("role");
  let query = "";
  // if (role === "Jogador" || role === "Treinador" || role === "Outro") {
  //   query = qs.stringify(
  //     {
  //       filters: {
  //         role: {
  //           $eq: role,
  //         },
  //       },
  //     },
  //     {
  //       encodeValuesOnly: true, // prettify URL
  //     }
  //   );
  // }

  if (accId) {
    query = qs.stringify(
      {
        filters: {
          creator: {
            id: {
              $eq: accId,
            },
          },
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
  }

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers?populate=*&${query}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getMyOffers = async () => {
  // my offers means either offers that I'm created or the ones I applied to
  const role = localStorage.getItem("role");
  let query = "";
  if (role === "Clube") {
    query = qs.stringify(
      {
        filters: {
          creator: {
            id: {
              $eq: localStorage.getItem("accountId"),
            },
          },
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
  } else {
    query = qs.stringify(
      {
        filters: {
          job_offer_applies: {
            account: {
              id: {
                $eq: localStorage.getItem("accountId"),
              },
            },
          },
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
  }

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers?populate=*&${query}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getOthersOffers = async () => {
  // my offers means either offers that I'm created or the ones I applied to
  const role = localStorage.getItem("role");
  let query = "";

  if (role === "Clube") {
    query = qs.stringify(
      {
        filters: {
          creator: {
            id: {
              $not: {
                $eq: localStorage.getItem("accountId"),
              },
            },
          },
          status: {
            $eq: "Publicado",
          },
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
  } else {
    query = qs.stringify(
      {
        filters: {
          role: {
            $eq: localStorage.getItem("role"),
          },
          status: {
            $eq: "Publicado",
          },
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
  }

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/job-offers?populate=*&${query}`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const updateOffer = async (body, id) => {
  let res = await axios.put(
    process.env.REACT_APP_BACKEND_URL + `api/job-offer-applies/${id}`,
    { data: body },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const applyOffer = async (body) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/job-offer-applies`,
    { data: body },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getOfferApplyList = async (offerId) => {
  const query = qs.stringify(
    {
      filters: {
        job_offer: {
          id: {
            $in: offerId,
          },
        },
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL +
      `api/job-offer-applies?${query}&populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getOfferApplyByAccount = async (offerId, accId) => {
  const query = qs.stringify(
    {
      filters: {
        job_offer: {
          id: {
            $eq: offerId,
          },
        },
        account: {
          id: {
            $eq: accId,
          },
        },
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL +
      `api/job-offer-applies?${query}&populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getSavedOffers = async (offersId = null) => {
  let filters = [];
  filters.push({
    type: "relation",
    field: "account",
    fieldRelation: "id",
    operator: "eq",
    value: localStorage.getItem("accountId"),
  });

  if (offersId && offersId.length > 0) {
    filters.push({
      type: "relation",
      field: "job_offer",
      fieldRelation: "id",
      operator: "in",
      value: offersId,
    });
  }

  let query = convertFilterQueryParams(filters);

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/saved-offers?filters[account][id]=${localStorage.getItem("accountId")}&${query}&populate=*`,
    getAuthorizationHeader()
  );

  let savedOffers = new Map();
  
  res.data.data.forEach((el) => {
    if(!el?.attributes?.job_offer?.data?.id) return;
    savedOffers.set(el.attributes.job_offer.data.id, el.id);
  });

  return savedOffers;
};

export const saveOffer = async (offerId) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/saved-offers`,
    {
      data: {
        account: localStorage.getItem("accountId"),
        job_offer: offerId,
      },
    },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const deleteSaveOffer = async (saveOfferId) => {
  await axios.delete(
    process.env.REACT_APP_BACKEND_URL + `api/saved-offers/${saveOfferId}`,
    getAuthorizationHeader()
  );

  return;
};
